import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";


export const userSettingsApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        findUserSettingsByGroupName: build.query({
            query: (groupName) => ({
                url: `/ajax/get-user-settings-by-group/${groupName}`,
                method: "GET",
                headers: getAuthorizationHeader()
            }),
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["userSettings"],
        }),
        updateUserSettings: build.mutation({
            query: (requestBody) => ({
                url: `/ajax/update-user-settings-by-id`,
                method: "PUT",
                headers: getAuthorizationHeader(),
                body: requestBody
            }),
            invalidatesTags: ["userSettings"],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled,"Updated","Table Setting")
            }
        }),
    }),
})

export const {
    useFindUserSettingsByGroupNameQuery,
    useUpdateUserSettingsMutation
} = userSettingsApi;